<template>
  <div class="tpl-popup">
    <div class="modal_titleForm">{{ $t('renew_change_policy_tpl_popup_header') }}</div>
    <div class="tpl-popup__desc">{{ $t('renew_change_policy_tpl_popup_desc') }}</div>
    <ul class="tpl-popup__list">
      <li>{{$t('renew_car_change_plan_damage')}}</li>
      <li>{{$t('renew_car_change_plan_roadside')}}</li>
      <li>{{$t('renew_car_change_plan_repairs')}}</li>
      <li>{{$t('renew_car_change_plan_deprecation')}}</li>
      <li>{{$t('renew_car_change_plan_benefit')}}</li>
      <li>{{$t('renew_car_change_plan_offroad')}}</li>
    </ul>
    <base-button class="btn-second btn-second_medium" @click.prevent="onSelect">{{ $t('renew_change_policy_tpl_popup_proceed') }}</base-button>
  </div>
</template>

<script>
export default {
  name: 'CarDowngradeToTplPopup',
  emits: ['select'],
  methods: {
    onSelect () {
      this.$emit('select')
    }
  }
}
</script>
